import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import Button from '../../components/Button';
import Header from '../../components/Header';
import Modal from '../../components/Modal';
import Loader from '../../components/Loader';
import Dimmer from '../../components/Dimmer';
import './styles.css';

class DeleteConnectionModal extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.object,
    deleteConnection: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
  };

  state = {
    requesting: false,
  };

  closeModal = () => {
    this.setState({ requesting: false });
    this.props.onClose();
  };

  deleteConnection = () => {
    this.props.deleteConnection();
  };

  render() {
    const { open } = this.props;
    const { requesting } = this.state;

    return (
      <Dimmer.Dimmable as={Modal} open={open}>
        <Dimmer
          tabIndex={-1}
          role="progressbar"
          aria-describedby="Delete SFTP Connection Configuration"
          aria-busy={requesting}
          inverted
          active={requesting}
        >
          <Loader active={requesting} />
        </Dimmer>
        <Header>
          Delete SFTP Connection Configuration?
        </Header>
        <Modal.Content>
          This cannot be undone. Are you sure you want to delete this SFTP connection configuration?
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.closeModal}>
            <FormattedMessage id="common.button.goback" defaultMessage="Go Back" />
          </Button>
          <Button primary onClick={this.deleteConnection} data-cy="delete-connection-modal-delete-button">
            <FormattedMessage id="common.button.delete" defaultMessage="Delete" />
          </Button>
        </Modal.Actions>
      </Dimmer.Dimmable>
    );
  }
}

export default injectIntl(DeleteConnectionModal);
